import { AbstractDimension } from '@orus.eu/dimensions'
import { type FrMrgaQuoteV3, type FrMrgaRatingFailure, quoteV3ToSerializedQuoteData } from '@orus.eu/pricing'
import type { Result } from '@orus.eu/result'

/** The rater could not price the input: no table row or formula for it. Business refusals are exclusions, not this. */
export type FrMrgaQuoteFailure = FrMrgaRatingFailure
export type FrMrgaQuoteResult = Result<FrMrgaQuoteV3, FrMrgaQuoteFailure>

export class FrMrgaQuoteDimension<NAME extends string> extends AbstractDimension<NAME, FrMrgaQuoteResult> {
  override formatToString(value: FrMrgaQuoteResult): string {
    if (value.type === 'failure') {
      return `NULL - ${value.problem.type}`
    }
    return quoteV3ToSerializedQuoteData(value.output)
  }
}

export const frMrgaQuoteDimension = new FrMrgaQuoteDimension({
  name: 'frMrgaQuote',
  displayKeys: { name: 'dimension_name_fr_mrga_quote' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
